import { ref } from "vue";

/**
 * The `preventNavigationHandler` mount arg of the legacy AppMount contract.
 * Remotes call it with true/false as their forms get dirty/clean (CustomersUI
 * via its usePreventNavigation composable). The host keeps a beforeunload
 * guard while dirty.
 */
export function createPreventNavigationHandler() {
  const isDirty = ref(false);

  function handler(dirty?: boolean): boolean {
    if (typeof dirty === "boolean") isDirty.value = dirty;
    return !isDirty.value;
  }

  function beforeUnloadListener(event: BeforeUnloadEvent) {
    if (isDirty.value) event.preventDefault();
  }

  return {
    handler,
    isDirty,
    install: () => window.addEventListener("beforeunload", beforeUnloadListener),
    uninstall: () => {
      window.removeEventListener("beforeunload", beforeUnloadListener);
      isDirty.value = false;
    },
    reset: () => {
      isDirty.value = false;
    },
  };
}
